import React, { useState } from "react";
import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import axios from 'axios';
import TopImage from "../components/common/TopImage";

function AdmissionEnquiryForm(props) {
  // State variables
  const [formValues, setFormValues] = useState({
    studentName: "",
    parentPhone: "",
    parentEmail: "",
    guardianName: "",
    address: "",
    currentClass: "",
    enquiryMessage: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Update state on input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    if (!formValues.studentName.trim()) {
      newErrors.studentName = 'Student name is required';
    }

    if (!formValues.parentPhone.trim()) {
      newErrors.parentPhone = 'Phone number is required';
    } else if (!/^[0-9\b]+$/.test(formValues.parentPhone)) {
      newErrors.parentPhone = 'Phone number must contain only numbers';
    }

    if (!formValues.parentEmail.trim()) {
      newErrors.parentEmail = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.parentEmail)) {
      newErrors.parentEmail = 'Invalid email format';
    }

    if (!formValues.guardianName.trim()) {
      newErrors.guardianName = 'Guardian name is required';
    }

    if (!formValues.address.trim()) {
      newErrors.address = 'Address is required';
    }

    if (!formValues.currentClass.trim()) {
      newErrors.currentClass = 'Class is required';
    }

    if (!formValues.enquiryMessage.trim()) {
      newErrors.enquiryMessage = 'Enquiry message is required';
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form fields
    if (!validateForm()) {
      return;
    }

    // If no errors, submit the form data
    try {
      // Simulating API call using setTimeout
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // TODO: Replace the following line with actual backend API endpoint
      await axios.post('http://localhost:5000/admission-enquiry', formValues);

      setIsSubmitted(true);
      setFormValues({
        studentName: "",
        parentPhone: "",
        parentEmail: "",
        guardianName: "",
        address: "",
        currentClass: "",
        enquiryMessage: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle error (e.g., show error message)
    }
  };
  
  return (
    <div>
      <NavBar/>
      <TopImage text="Admission Enquiry"/>
      <div className="text-2xl ml-28 max-md:ml-8 mt-20 max-md:mt-8 tracking-wide text-black max-w-[684px] ">
        Kindly fill in the form to get in touch with the admission cell.
      </div>
      <div className="flex justify-center items-center mb-20">
        <div className="bg-admission-color flex flex-col mt-20 max-md:mt-10 px-14 py-11 text-base font-medium tracking-wide text-gray-400 capitalize rounded-xl shadow-lg max-w-[880px] max-md:px-5 max-md:w-10/12">
          <div className="text-3xl mt-5 font-bold text-center tracking-wide text-black max-md:max-w-full">
            Admission Enquiry
          </div>
          <form onSubmit={handleSubmit}>
            <div className="justify-center items-start px-8 py-4 mt-16 whitespace-nowrap rounded-xl bg-slate-50 max-md:px-5 max-md:mt-10 max-md:max-w-full border-2 border-solid border-gray-300">
              <input
                type="text"
                id="studentName"
                name="studentName"
                placeholder="Name"
                value={formValues.studentName}
                onChange={handleChange}
                className={`p-2 w-full bg-slate-50 text-black focus:outline-none ${errors.studentName ? 'border-red-500' : ''}`}  
                style={{ fontSize: "1.2rem" }}
              />
              {errors.studentName && (
                  <p className="text-red-500 text-sm mt-1">{errors.studentName}</p>
              )}
            </div>
            <div className="flex gap-5 justify-between mt-5 whitespace-nowrap max-md:flex-wrap max-md:max-w-full">
              <div className="grow justify-center items-start px-7 py-4 rounded-xl bg-slate-50 max-md:px-  border-2 border-solid border-gray-300 ">
                <input
                  type="tel"
                  id="parentPhone"
                  name="parentPhone"
                  placeholder="Parent Phone"
                  value={formValues.parentPhone}
                  onChange={handleChange}
                  className={`p-2 bg-slate-50 max-md:w-full text-black focus:outline-none ${errors.parentPhone ? 'border-red-500' : ''}`}
                  style={{ fontSize: "1.2rem" }}

                />
                {errors.parentPhone && (
                    <p className="text-red-500 text-sm mt-1">{errors.parentPhone}</p>
                  )}
              </div>
              <div className="grow justify-center items-start px-8 py-4 rounded-xl bg-slate-50 max-md:px-5  border-2 border-solid border-gray-300">
                <input
                  type="email"
                  id="parentEmail"
                  name="parentEmail"
                  placeholder="Parent Email"
                  value={formValues.parentEmail}
                  onChange={handleChange}
                  className={`p-2 w-10/12 bg-slate-50 text-black max-md:w-3/4 focus:outline-none ${errors.parentEmail ? 'border-red-500' : ''}`}
                  style={{ fontSize: "1.2rem" }}

                />
                {errors.parentEmail && (
                  <p className="text-red-500 text-sm mt-1">{errors.parentEmail}</p>
                )}
              </div>
            </div>
            <div className="justify-center items-start px-8 py-4 mt-5 whitespace-nowrap rounded-xl bg-slate-50 max-md:px-5 max-md:max-w-full  border-2 border-solid border-gray-300">
              <input
                type="text"
                id="guardianName"
                name="guardianName"
                placeholder="Guardian Name"
                value={formValues.guardianName}
                onChange={handleChange}
                className={`p-2 w-10/12 bg-slate-50 text-black max-md:w-full focus:outline-none ${errors.guardianName ? 'border-red-500' : ''}`}
                style={{ fontSize: "1.2rem" }}

                />
                {errors.guardianName && (
                  <p className="text-red-500 text-sm mt-1">{errors.guardianName}</p>
                )}
            </div>
            <div className="items-start px-8 py-4 mt-5 rounded-xl bg-slate-50 max-md:px-5 max-md:pb-10 max-md:max-w-full  border-2 border-solid border-gray-300">
              <textarea
                  id="address"
                  name="address"
                  placeholder="Address"
                  rows="4"
                  value={formValues.address}
                  onChange={handleChange}
                  className={`w-full p-2 mt-2 rounded-md text-black bg-slate-50 focus:outline-none ${errors.address ? 'border-red-500' : ''}`}
                  style={{ fontSize: "1.2rem" }}

                ></textarea>
                {errors.address && (
                  <p className="text-red-500 text-sm mt-1">{errors.address}</p>
                )}
            </div>

            <div className="justify-center items-start px-8 py-4 mt-5 whitespace-nowrap rounded-xl bg-slate-50 max-md:px-5 max-md:max-w-full  border-2 border-solid border-gray-300">
              <input
                type="text"
                id="currentClass"
                name="currentClass"
                placeholder="Current Class"
                value={formValues.currentClass}
                onChange={handleChange}
                className={`p-2 w-11/12 bg-slate-50  text-black max-md:w-full focus:outline-none ${errors.currentClass ? 'border-red-500' : ''}`}
                style={{ fontSize: "1.2rem" }}

                />
                {errors.currentClass && (
                  <p className="text-red-500 text-sm mt-1">{errors.currentClass}</p>
                )}
            </div>
            <div className="items-start px-8 py-4 mt-5 rounded-xl bg-white max-md:px-5 max-md:pb-10 max-md:max-w-full border-2 border-solid border-gray-300">
              <textarea
                  id="enquiryMessage"
                  name="enquiryMessage"
                  placeholder="Enquiry Message"
                  rows="4"
                  value={formValues.enquiryMessage}
                  onChange={handleChange}
                  className={`w-full p-2 mt-2 rounded-md text-black bg-white focus:outline-none ${errors.enquiryMessage ? 'border-red-500' : ''}`}
                  style={{ fontSize: "1.2rem" }}

                ></textarea>
                {errors.enquiryMessage && (
                  <p className="text-red-500 text-sm mt-1">{errors.enquiryMessage}</p>
                )}
            </div>

            <div className="justify-center items-center text-center py-3 mt-16 text-2xl font-bold tracking-wide whitespace-nowrap bg-sky-600 rounded-xl text-slate-300 max-md:px-5 max-md:mt-10 max-md:max-w-full">
              <button type="submit">
                  Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default AdmissionEnquiryForm;
